import { DEFAULT_FORM_FILL_ACCENT } from "@v1/backend/logic/forms/public_branding";
import type { CSSProperties } from "react";
import { resolveHexAccentColor } from "../../task_workspace/boards/board-badge-tone";

interface RgbComponents {
  readonly r: number;
  readonly g: number;
  readonly b: number;
}

function parseHexRgb(hex: string): RgbComponents | null {
  const match = /^#?([0-9a-fA-F]{6})$/.exec(hex.trim());
  const cap = match?.[1];
  if (!cap) return null;
  const n: number = Number.parseInt(cap, 16);
  return { r: (n >> 16) & 255, g: (n >> 8) & 255, b: n & 255 };
}

export function resolveFormFillAccent(accentColor: string): string {
  return resolveHexAccentColor(accentColor, DEFAULT_FORM_FILL_ACCENT);
}

/** Text on accent-filled buttons — light accents need dark text. */
export function pickFormFillOnAccentText(accentColor: string): string {
  const rgb: RgbComponents | null = parseHexRgb(
    resolveFormFillAccent(accentColor),
  );
  const r: number = rgb?.r ?? 0;
  const g: number = rgb?.g ?? 128;
  const b: number = rgb?.b ?? 112;
  const luminance: number = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return luminance > 0.62 ? "#171717" : "#ffffff";
}

export function formFillAccentStyleVars(accentColor: string): CSSProperties {
  const swatch: string = resolveFormFillAccent(accentColor);
  const rgb: RgbComponents | null = parseHexRgb(swatch);
  const r: number = rgb?.r ?? 0;
  const g: number = rgb?.g ?? 128;
  const b: number = rgb?.b ?? 112;
  return {
    ["--form-fill-accent" as string]: swatch,
    ["--form-fill-accent-band" as string]: `rgba(${r}, ${g}, ${b}, 0.05)`,
    ["--form-fill-accent-soft" as string]: `rgba(${r}, ${g}, ${b}, 0.1)`,
    ["--form-fill-on-accent" as string]: pickFormFillOnAccentText(swatch),
  };
}
